import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Label } from 'recharts';

/**
 * PC_Tc_04 getTeamCountData gets imported from api.js file
 */

import { getTeamCountData } from '../service/api';
import '../components/css/Dashboard-styles.css';

export default function TeamCountData(props) {
    /**
     * PC_Tc_02
     * The data state variable is created for storing the response data
     */

    const [data, setData] = useState();
    const [filterFunction, setFilterFunction] = useState();

    const navigate = useNavigate();

    /**
     * PC_Tc_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {
        if (props.filterFunction !== undefined) {
            setFilterFunction(props.filterFunction);
            fetchApi(props.filterFunction);
            // props.resetData()
        }
    }, [props, props.filterFunction.start_date, props.filterFunction.end_date]);

    /**
     * PC_Tc_06
     * The fetchApi function in the useEffects gets invoked which inturn call the getTeamCountData() function with respective parameters
     */

    const fetchApi = async (filterData = {}) => {
        let resp;

        if (filterData.start_date || filterData.end_date) {
            resp = await getTeamCountData(filterData);
        } else {
            resp = await getTeamCountData();
        }
        if (resp?.data?.ResponseData?.length) setData(resp.data.ResponseData);
    };

    const handleClick = (e) => {
        navigate('/TeamDirectory?dashboard=true', {
            state: { domain: e?.name, start_date: props?.filterFunction?.start_date, end_date: props?.filterFunction?.end_date },
        });
    };

    /**
     * PC_Tc_10
     * The response data gets stored in the data variable and passed to the BarChart
     */

    return (
        <div className="db-widget-x-scrl">
            <BarChart
                width={2000}
                height={255}
                data={data}
                // style={{padding-bottom:20px;}}
                className="db-widget-spacing"
                margin={{
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0,
                }}
            >
                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                <XAxis
                    dataKey="name"
                    margin={{ left: 100 }}
                    style={{
                        fontSize: '0px',
                        fontFamily: 'SF Pro Regular',
                        color: '#959595',
                    }}
                    label={{ value: 'Domains', dx: 5, dy: 10, fontSize: 12, fontFamily: 'SF Pro Regular', fill: '#959595', color: '#959595' }}
                >
                    {/* <Label position="insideBottom" value="Domains" style={{
                fontSize: '12px',
                fontFamily: 'SF Pro Regular',
                color: "#959595"
            }} />  */}
                </XAxis>
                <YAxis
                    style={{
                        fontSize: '10px',
                        fontFamily: 'SF Pro Regular',
                        color: '#959595',
                    }}
                    domain={[0, 250]}
                    label={{
                        value: 'No of Team Members',
                        angle: -90,
                        position: 'insideLeft',
                        dx: 5,
                        dy: 80,
                        fontSize: 12,
                        fontFamily: 'SF Pro Regular',
                        fill: '#959595',
                        color: '#959595'
                    }}
                >
                    {/* <Label value='No. of Employees' offset={6} position='insideLeft' angle="-90" style={{
                fontSize: '12px',
                fontFamily: 'SF Pro Regular',
                color: "#959595"
            }} /> */}
                </YAxis>
                <Tooltip />
                {/* <Legend /> */}
                <Bar
                    dataKey="Domain"
                    fill="#F29B10"
                    onClick={(e) => {
                        handleClick(e);
                    }}
                >
                    <LabelList dataKey="Domain" position="top" />
                </Bar>
                {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
            </BarChart>
        </div>
    );
}
